export default class sliderSwiper {
    constructor(elm) {
        if (elm.querySelectorAll('.swiper-slide').length === 0) return;
        const latestPickerSlider = elm.classList.contains('swiper-container__latest-picker');
        let slidesPerViewNumber = 2;

        if (latestPickerSlider) {
            slidesPerViewNumber = 3;
        }
        this.elm = elm;
        this.options = {
            loop: false,
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            updateOnWindowResize: true,
            spaceBetween: 10,
            slideActiveClass: 'swiper-slide-active',
            slidePrevClass: 'swiper-slide-prev',
            slideNextClass: 'swiper-slide-next',

            breakpointsBase: 'window',

            breakpoints: {

                320: {
                    slidesPerView: 1.03,
                },
                800: {
                    slidesPerView: 2,
                    spaceBetween: 29,
                    slideActiveClass: 'swiper-slide-active',
                    slidePrevClass: 'swiper-slide-prev',
                    slideNextClass: 'swiper-slide-next',
                },
                1200: {
                    slidesPerView: slidesPerViewNumber,
                    spaceBetween: 29,
                    slideActiveClass: 'swiper-slide-active',
                    slidePrevClass: 'swiper-slide-prev',
                    slideNextClass: 'swiper-slide-next',
                },
            },
        };

        this.swiper = import('swiper').then(slider => new slider.Swiper(this.elm, this.options));
    }

    update() {
        this.swiper.update();
    }

    destroy() {
        this.swiper.destroy();
    }
}
